var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import styled from 'styled-components';
import { DonutChart } from '../Charts';
import { OnScrollWrapper } from '../UtilityWrappers';
import { RichH3 } from '../Typography';
import { isFieldValid } from '../../utils/validation';
import media from '../../utils/media';
const GraphicContainer = styled.div `
  background-color: ${({ theme }) => theme.primaryWhite};
  height: 400px;

  ${media.mobile} {
    height: 230px;
  }
`;
const TitleContainer = styled.div `
  display: flex;
  justify-content: center;
  margin-bottom: 48px;

  ${media.mobile} {
    margin-bottom: 28px;
  }
`;
export const DonutChartGraphic = ({ fields }) => {
    const [isChartInView, setIsChartInView] = useState(false);
    if (!fields) {
        return null;
    }
    const { chartTitle } = fields, rest = __rest(fields, ["chartTitle"]);
    const donutDataArray = [];
    for (let i = 0; i < 5; i++) {
        if (isFieldValid(rest[`chartLabel${i + 1}`]) && isFieldValid(rest[`chartValue${i + 1}`])) {
            const { value: name } = rest[`chartLabel${i + 1}`];
            const { value } = rest[`chartValue${i + 1}`];
            donutDataArray.push({
                name: name,
                value: parseFloat(value),
            });
        }
    }
    return (React.createElement(GraphicContainer, null,
        React.createElement(OnScrollWrapper, { onVisibilityChange: setIsChartInView },
            React.createElement(React.Fragment, null,
                isFieldValid(chartTitle) && (React.createElement(TitleContainer, null,
                    React.createElement(RichH3, { field: chartTitle }))),
                React.createElement(DonutChart, { data: donutDataArray, initiateAnimate: isChartInView })))));
};
